import Cookies from "js-cookie"
import { decrypte, encrypte } from "./crypto";
import { useAuthStore } from "@/stores/auth";

const cookiesHandler = {
    hasAcceptedCookies() {
        const authStore = useAuthStore();
        if(authStore.isAuthenticated)
            return true;
        
        let acceptedCookies = Cookies.get('accepted_cookies');
        return ![null,undefined,''].includes(acceptedCookies) ? true : false;
    },

    hasCookie(cookieName = ''){
        return ![null,undefined,''].includes(Cookies.get(cookieName)) ? true : false;
    },

    saveCookieAcecptance(){
        Cookies.set('accepted_cookies', '1');
    },

    removeCookieAcceptance(){
        Cookies.remove('accepted_cookies');
    },

    setEncryptedCookie(cookieName, value = '', timeInMinutes = null){
        let expirationTime = null;

        try {
            if (timeInMinutes && parseInt(timeInMinutes)) {
                expirationTime = parseInt(timeInMinutes) + 'MIN';
            }
            
        } catch (error) {
            expirationTime = '1440MIN';    
        }
        expirationTime = '1440MIN';
        Cookies.set(cookieName, encrypte(value), expirationTime);
    },

    getEncryptedCookie(cookieName){
        return decrypte(Cookies.get(cookieName));
    },

    save(cookieName, value, timeInMinutes = null){
        let expirationTime = null;

        try {
            if (timeInMinutes && parseInt(timeInMinutes)) {
                expirationTime = parseInt(timeInMinutes) + 'MIN';
            }
            
        } catch (error) {
            expirationTime = '1440MIN';    
        }
        expirationTime = '1440MIN';

        Cookies.set(cookieName, value, expirationTime);
    },

    get(cookieName){
        return Cookies.get(cookieName);
    },

    delete(cookieName) {
        return Cookies.remove(cookieName);
    }
}

export default cookiesHandler;